import "./style/index.scss";
import * as Icon from "@ant-design/icons";
import { Col, Flex, Form, Modal, Row } from "antd";
import { ColumnsType } from "antd/es/table";
import Search from "antd/lib/input/Search";
import { useEffect, useState } from "react";
import { PerfilTaxaImpostoModel } from "../../../../models/perfilTaxaImposto/perfilTaxaImpostoModel";
import { TaxaImpostoDtoModel } from "../../../../models/perfilTaxaImposto/taxaImpostoDtoModel";
import { setTitle } from "../../../../redux/slices/configuracoes/configuracoesSlice";
import {
  setDetalhesImposto,
  setListSelect,
  setEntityPerfilTaxaImposto,
  setPagePerfilTaxaImposto,
  setModalDeletarPerfilTaxaImposto,
  setBuscaPerfilTaxaImposto,
} from "../../../../redux/slices/perfilTaxaImposto/perfilTaxaImpostoSlice";
import { buscarPerfilTaxaImposto, deletarPerfilTaxaImposto } from "../../../../services/perfilTaxaImpostoService";
import { buscarTaxaImposto } from "../../../../services/taxaImpostoService";
import { useAppSelector, useAppDispatch } from "../../../../util/hooks";
import { currencyBRL } from "../../../../util/dinheiroBRAuxiliar";
import MensagemModal from "../../../../components/modal/mensagem";
import TableComponent from "../../../../components/table/tableComponent";
import { ItemMenuAcoes } from "../../../../models/sistema/itemMenuAcoes";
import AcoesComponent from "../../../../components/table/acoesComponent";
import { ButtonComponent } from "../../../../components/button/cadastrar";
import { SelectedRowKeysModel } from "../../../../models/sistema/selectedRowKeysModel";

const GeralPage = () => {
  //estados Globais
  const perfilTaxaImpostoState = useAppSelector((state) => state.perfilTaxaImposto);
  const taxaImpostoState = useAppSelector((state) => state.taxaImposto);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [selectedRowKeys, setSelectedRowKeys] = useState<SelectedRowKeysModel>({ keys: [], rows: [] } as SelectedRowKeysModel);

  useEffect(() => {
    dispatch(setTitle("PERFIL DE TAXA DE IMPOSTO"));
    dispatch(buscarTaxaImposto(taxaImpostoState.busca));
    dispatch(buscarPerfilTaxaImposto(perfilTaxaImpostoState.busca));
  }, []);

  const goCadastrar = () => {
    dispatch(setEntityPerfilTaxaImposto({}));
    dispatch(setListSelect(taxaImpostoState.list));
    dispatch(setPagePerfilTaxaImposto("cadastrar"));
  };

  const goEditar = (value: PerfilTaxaImpostoModel) => {
    var options: any[] = [];
    const idsTaxaImposto = value.detalhes.map((taxaImposto: any) => taxaImposto.id);
    taxaImpostoState.list.forEach((perfilTaxaImposto: any) => !idsTaxaImposto.includes(perfilTaxaImposto.id) && options.push(perfilTaxaImposto));
    dispatch(setListSelect(options));
    dispatch(setEntityPerfilTaxaImposto(value));
    dispatch(setPagePerfilTaxaImposto("cadastrar"));
  };

  const goDeletar = (value: PerfilTaxaImpostoModel) => {
    dispatch(setEntityPerfilTaxaImposto(value));
    dispatch(setModalDeletarPerfilTaxaImposto(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarPerfilTaxaImposto(false));
  };

  const selecionarLinha = (value: SelectedRowKeysModel) => {
    setSelectedRowKeys(value);
    let detalhesTaxa: TaxaImpostoDtoModel[] = [];

    value.rows[0].detalhes.forEach(async (detalhe: TaxaImpostoDtoModel) => {
      detalhesTaxa.push(detalhe);
    });

    dispatch(setDetalhesImposto(detalhesTaxa));
  };

  const onSearch = (value: string) => {
    dispatch(buscarPerfilTaxaImposto(value));
    dispatch(setBuscaPerfilTaxaImposto(value));
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
  ];

  const columns: ColumnsType<PerfilTaxaImpostoModel> = [
    {
      title: "DENOMINAÇÃO",
      dataIndex: "denominacao",
      sorter: (a: any, b: any) => a.denominacao.localeCompare(b.denominacao),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "PERCENTUAL",
      dataIndex: "percentual",
      align: "center",
      sorter: (a: any, b: any) => a.percentual - b.percentual,
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => (record.percentual !== null ? `${record.percentual},00%` : "0,00%"),
    },
    {
      title: "VALOR FIXO",
      dataIndex: "valorFixoImposto",
      align: "center",
      sorter: (a: any, b: any) => a.percentual - b.percentual,
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => (record.valorFixoImposto !== null ? currencyBRL(record.valorFixoImposto) : currencyBRL(0)),
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      onCell: (record) => {
        return {
          onClick: (event) => {
            event.stopPropagation();
          },
        };
      },
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  const columnsDetalhePerfil: ColumnsType<TaxaImpostoDtoModel> = [
    {
      title: "IMPOSTO",
      dataIndex: "denominacao",
      sorter: (a: any, b: any) => a.denominacao.localeCompare(b.denominacao),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "PERCENTUAL/VALOR",
      align: "center",
      sorter: (a: any, b: any) => {
        const valueA = a.valorFixoImposto ?? a.percentual ?? 0;
        const valueB = b.valorFixoImposto ?? b.percentual ?? 0;
        return valueA - valueB;
      },
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => (record.valorFixoImposto !== null ? currencyBRL(record.valorFixoImposto) : `${record.percentual?.toFixed(2)}%`),
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical">
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              <Form.Item label="Pesquisar" name="pesquisar">
                <Search allowClear placeholder="Denominação" onSearch={onSearch} className="searchInput" enterButton style={{ width: 300 }} />
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="end">
              <ButtonComponent onClick={goCadastrar} />
            </Flex>
          </Col>
        </Row>
      </Form>
      <Flex gap={12}>
        <TableComponent
          data={perfilTaxaImpostoState.list}
          columns={columns}
          loading={perfilTaxaImpostoState.loading}
          selectionType="radio-allowed"
          rowSelection={selecionarLinha}
          tableProps={{
            className: "tableGeneralPerfil",
            onRow: (record: PerfilTaxaImpostoModel) => {
              return {
                onClick: () => {
                  selecionarLinha({ keys: [record.id], rows: [record] });
                },
              };
            },
            selectedRowKeys: selectedRowKeys.keys,
            style: { width: "100%" },
          }}
        />
        <TableComponent
          data={perfilTaxaImpostoState.detalhesImposto}
          columns={columnsDetalhePerfil}
          loading={perfilTaxaImpostoState.loading}
          pagination={false}
          tableProps={{
            style: { width: 600 },
          }}
        />
      </Flex>
      <Modal title={"REMOVER PERFIL DE TAXA DE IMPOSTO"} centered width={350} open={perfilTaxaImpostoState.modalDeletar} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal
          text="Deseja remover o perfil de taxa de imposto?"
          action={deletarPerfilTaxaImposto({ value: perfilTaxaImpostoState.entity.id, busca: perfilTaxaImpostoState.busca })}
          close={setModalDeletarPerfilTaxaImposto(false)}
        />
      </Modal>
    </Flex>
  );
};

export default GeralPage;
